<div class="wrapper" id="wrapper-content">
  @if (hideSomeComponents === false) {
    <app-mfa-popup></app-mfa-popup>
  }
  <app-loader></app-loader>
  <app-alert-messages></app-alert-messages>
  @if (null !== customer && hideSomeComponents === false) {
    <app-menu [brand]="brand" [customer]="customer"></app-menu>
  }
  @if (customer == null || hideSomeComponents === true) {
    <router-outlet></router-outlet>
  }
  <app-check-password></app-check-password>
  @if (customer) {
    <app-pro-fleet-modal></app-pro-fleet-modal>
  }
  @if (customer !== null && hideSomeComponents === false) {
    <div [id]="'app-style-' + brand" class="main-panel">
      <div class="content">
        <div class="row pt-3 bg-img">
          <div class="col-12">
            @if (supportUser) {
              <div class="blue-div-content">
                Vous êtes connecté en tant que conseiller.
                <br/>
                <strong>Client :</strong> {{ '[' + customer.id + ']' + ' ' + customer.firstName + ' ' + customer.lastName }} {{ customer.company ? ' - ' + customer.company : ''}}
                @if (customer.customersSalesAssignments) {
                  <div>
                    <strong>Responsable commercial:</strong> {{ customer.customersSalesAssignments.salesManager }}
                    <br/>
                    <strong>Agence: </strong>{{ customer.customersSalesAssignments.agency }}
                  </div>
                }
                @if (customer.isFraudster) {
                  <div>
                    <strong>Statut : </strong><span class="bold-red-text">fraudeur</span>
                  </div>
                }
                <div>
                  <div class="w-100 pt-3 text-center">
                    <button type="button" class="cta_btn level_2" (click)="displayNotesModal()">Ajouter une note<span></span></button>
                  </div>
                  <app-notes-popup></app-notes-popup>
                </div>
              </div>
            }
            @if (supportUser == null) {
              <div class="first-name-title">
                <h1><span>Bonjour </span> {{ customer.firstName }}</h1>
              </div>
            }
            @if (!supportUser && brand == 'prixtel') {
              <div class="blue-div-content">
                  <img src="../assets/images/gift.png" width="30" /> &nbsp;<strong>Nouveau</strong><br/>
                  Gagnez <strong class="prixtel-color">1 mois de forfait gratuit</strong> en parrainant vos amis ! <a href="/parrainage/liste" class="underline">Je parraine</a>
              </div>
            }
            @if (twoGLines.length > 0) {
              <div class="blue-div-content">
                  <img src="../assets/images/icons/yellow_triangle.png" width="15" />
                  <strong class="title">Arrêt du réseau 2G</strong>
                  <br/>
                  <div>
                      @if (twoGLines.length > 4) {
                          @if (isPro) {
                              Certains de vos utilisateurs utilisent un matériel 2G. A compter de mi-novembre, le réseau 2G sera arrêté et ces matériels cesseront de fonctionner. Nous vous invitons à <strong>remplacer au plus tôt votre matériel avec un modèle 4G ou 5G</strong> afin de continuer à bénéficier de vos abonnements et services.&nbsp;
                          } @else {
                              Vous utilisez des téléphones 2G avec certaines de vos lignes. Mi-novembre, le réseau 2G ne fonctionnera plus. Pour continuer à utiliser vos lignes, vous devez <strong>remplacer ces téléphones par des modèles compatibles 4G ou 5G</strong>.&nbsp;
                          }
                      } @else if (twoGLines.length >= 2 && twoGLines.length <= 4) {
                          Vous utilisez des téléphones 2G avec vos lignes<strong>{{ getTwoGLines() }}</strong>. Mi-novembre, le réseau 2G ne fonctionnera plus. Pour continuer à utiliser vos lignes, vous devez <strong>remplacer vos téléphones par des modèles compatibles 4G ou 5G</strong>.&nbsp;
                      } @else {
                          Vous utilisez un téléphone 2G avec votre ligne<strong>{{ getTwoGLines() }}</strong> et mi-novembre, le réseau 2G ne fonctionnera plus. Pour continuer à utiliser votre ligne, vous devez <strong>remplacer votre téléphone par un modèle compatible 4G ou 5G</strong>.&nbsp;
                      }
                      @if (isPro) {
                          Pour plus d'informations, veuillez contacter votre Service client.
                      } @else if (getHrefValue()) {
                          <a [href]="getHrefValue()" class="underline" target="_blank">En savoir plus</a>
                      }
                  </div>
              </div>
            }
            @if (!supportUser) {
              <app-message-board></app-message-board>
            }
            <div class="card card-initial page-body p-3">
              <router-outlet></router-outlet>
               @if (brand === 'prixtel' || brand === 'coriolis') {
                  <footer class="app-footer">
                    <a href="{{ vitrineUrl }}/accessibilite">Accessibilité : non conforme</a>
                  </footer>
               }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
